import { PROPERTY_CHICAGO } from './constants';

export const roomRateIsComp = (amount, property) => {
  if (property === PROPERTY_CHICAGO && amount === 0) {
    return true;
  }
  return amount === 4501 || amount === 4500;
};
